"use client"

import { useState,useEffect } from "react"
import { getAllCurrencies } from "../../api/currencyService"
import { addCompany } from "../../api/company"

export default function CompanyForm() {
  const [formData, setFormData] = useState({
    companyName: "",
    loginEmail: "",
    password: "",
    dateEstablished: "",
    taxVatNumber: "",
    address: "",
    city: "",
    country: "",
    postalCode: "",
    mainPhoneNumber: "",
    emailAddress: "",
    website: "",
    defaultCurrency: "USD",
    applicableTaxes: [],
    operatingPorts: [],
    operatingCountries: [],
    timeZone: "",
    workingHours: "",
    whoWeAre: "",
    vision: "",
    mission: "",
    purpose: "",
    facebookUrl: "",
    instagramUrl: "",
    whatsappNumber: "",
    linkedinProfile: "",
    skypeId: "",
    approveNow: false,
  })

  const [logoFile, setLogoFile] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")
  const [success, setSuccess] = useState("")
  const [currencies, setCurrencies] = useState([])
  const [loadingCurrencies, setLoadingCurrencies] = useState(true)


   useEffect(() => {
    const fetchCurrencies = async () => {
      setLoadingCurrencies(true)
      const currencyList = await getAllCurrencies()
      setCurrencies(currencyList)
      setLoadingCurrencies(false)
    }

    fetchCurrencies()
  }, [])

  // Handle input changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target

    if (type === "checkbox") {
      setFormData((prev) => ({ ...prev, [name]: checked }))
    } else if (type === "select-multiple") {
      const selectedOptions = Array.from(e.target.selectedOptions, (option) => option.value)
      setFormData((prev) => ({ ...prev, [name]: selectedOptions }))
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }))
    }
  }

  // Handle file input
  const handleFileChange = (e) => {
    const file = e.target.files[0]
    setLogoFile(file || null)
  }

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError("")
    setSuccess("")

    try {
      await addCompany(formData, logoFile)
      setSuccess("Company added successfully!")
      // Reset form
      setFormData({
        companyName: "",
        loginEmail: "",
        password: "",
        dateEstablished: "",
        taxVatNumber: "",
        address: "",
        city: "",
        country: "",
        postalCode: "",
        mainPhoneNumber: "",
        emailAddress: "",
        website: "",
        defaultCurrency: "USD",
        applicableTaxes: [],
        operatingPorts: [],
        operatingCountries: [],
        timeZone: "",
        workingHours: "",
        whoWeAre: "",
        vision: "",
        mission: "",
        purpose: "",
        facebookUrl: "",
        instagramUrl: "",
        whatsappNumber: "",
        linkedinProfile: "",
        skypeId: "",
        approveNow: false,
      })
      setLogoFile(null)
    } catch (err) {
      setError(err.message || "Failed to add company")
    } finally {
      setLoading(false)
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="row g-4">
        {error && (
          <div className="col-12">
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          </div>
        )}
        {success && (
          <div className="col-12">
            <div className="alert alert-success" role="alert">
              {success}
            </div>
          </div>
        )}

        {/* Basic Company Info */}
        <div className="col-md-12">
          <div className="card flex-fill">
            <div className="card-header">
              <div className="d-flex justify-content-between align-items-center">
                <h5 className="card-title">Basic Company Information</h5>
              </div>
            </div>
            <div className="card-body">
              <div className="mb-3">
                <label className="form-label">Company Name</label>
                <input
                  type="text"
                  name="companyName"
                  className="form-control"
                  placeholder="Enter company name"
                  value={formData.companyName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Tax / VAT Number</label>
                <input
                  type="text"
                  name="taxVatNumber"
                  className="form-control"
                  placeholder="Enter Tax/VAT number"
                  value={formData.taxVatNumber}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Logo</label>
                <input type="file" name="logo" className="form-control" onChange={handleFileChange} accept="image/*" />
              </div>
              <div className="mb-3">
                <label className="form-label">Date Established</label>
                <input
                  type="date"
                  name="dateEstablished"
                  className="form-control"
                  value={formData.dateEstablished}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Login Information */}
        <div className="col-md-12">
          <div className="card flex-fill">
            <div className="card-header">
              <div className="d-flex justify-content-between align-items-center">
                <h5 className="card-title">Login Information</h5>
              </div>
            </div>
            <div className="card-body">
              <div className="mb-3">
                <label className="form-label">Login Email</label>
                <input
                  type="email"
                  name="loginEmail"
                  className="form-control"
                  placeholder="Login email for company portal"
                  value={formData.loginEmail}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Password</label>
                <input
                  type="password"
                  name="password"
                  className="form-control"
                  placeholder="Enter password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
          </div>
        </div>

        {/* Contact Details */}
        <div className="col-md-12">
          <div className="card flex-fill">
            <div className="card-header">
              <div className="d-flex justify-content-between align-items-center">
                <h5 className="card-title">Contact Details</h5>
              </div>
            </div>
            <div className="card-body">
              <div className="mb-3">
                <label className="form-label">Address</label>
                <input
                  type="text"
                  name="address"
                  className="form-control"
                  placeholder="Street Address"
                  value={formData.address}
                  onChange={handleChange}
                />
              </div>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">City</label>
                  <input
                    type="text"
                    name="city"
                    className="form-control"
                    placeholder="City"
                    value={formData.city}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Country</label>
                  <input
                    type="text"
                    name="country"
                    className="form-control"
                    placeholder="Country"
                    value={formData.country}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="mb-3">
                <label className="form-label">Postal Code</label>
                <input
                  type="text"
                  name="postalCode"
                  className="form-control"
                  placeholder="Postal Code"
                  value={formData.postalCode}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Main Phone Number</label>
                <input
                  type="text"
                  name="mainPhoneNumber"
                  className="form-control"
                  placeholder="+1 234 567 890"
                  value={formData.mainPhoneNumber}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Email Address</label>
                <input
                  type="email"
                  name="emailAddress"
                  className="form-control"
                  placeholder="example@email.com"
                  value={formData.emailAddress}
                  onChange={handleChange}
                />
              </div>
              {/* <div className="mb-3">
                <label className="form-label">Website</label>
                <input
                  type="text"
                  name="website"
                  className="form-control"
                  placeholder="https://"
                  value={formData.website}
                  onChange={handleChange}
                />
              </div> */}
            </div>
          </div>
        </div>

        {/* Operational Details */}
        <div className="col-md-12">
          <div className="card flex-fill">
            <div className="card-header">
              <div className="d-flex justify-content-between align-items-center">
                <h5 className="card-title">Operational Details</h5>
              </div>
            </div>
            <div className="card-body">
                          <div className="mb-3">
                            <label className="form-label">Default Currency</label>
                            <select
                        className="form-select"
                        name="defaultCurrency"
                        value={formData.defaultCurrency}
                        onChange={handleChange}
                        disabled={loadingCurrencies || currencies.length === 0}
                      >
                        {loadingCurrencies ? (
                          <option>Loading currencies...</option>
                        ) : currencies.length === 0 ? (
                          <option>No currencies available</option>
                        ) : (
                          currencies.map((currency) => (
                            <option key={currency.code} value={currency.code}>
                              {currency.code} - {currency.name}
                            </option>
                          ))
                        )}
                      </select>
                          </div>

              <div className="mb-3">
                <label className="form-label">Applicable Taxes</label>
                <select
                  className="form-select"
                  name="applicableTaxes"
                  multiple
                  value={formData.applicableTaxes}
                  onChange={handleChange}
                >
                  <option value="VAT">VAT</option>
                  <option value="Excise">Excise</option>
                  <option value="Service Tax">Service Tax</option>
                </select>
                <small className="text-muted">Hold Ctrl (Cmd on Mac) to select multiple.</small>
              </div>

              {/* <div className="mb-3">
                <label className="form-label">Operating Ports</label>
                <select
                  className="form-select"
                  name="operatingPorts"
                  multiple
                  value={formData.operatingPorts}
                  onChange={handleChange}
                >
                  <option value="Port Sudan">Port Sudan</option>
                  <option value="Suakin">Suakin</option>
                  <option value="Jeddah">Jeddah</option>
                  <option value="Port A">Port A</option>
                  <option value="Port B">Port B</option>
                  <option value="Port C">Port C</option>
                  <option value="Port D">Port D</option>
                </select>
                <small className="text-muted">Hold Ctrl (Cmd on Mac) to select multiple.</small>
              </div> */}

              <div className="mb-3">
                <label className="form-label">Operating Countries</label>
                <select
                  className="form-select"
                  name="operatingCountries"
                  multiple
                  value={formData.operatingCountries}
                  onChange={handleChange}
                >
                  <option value="Sudan">Sudan</option>
                  <option value="Saudi Arabia">Saudi Arabia</option>
                  <option value="UAE">UAE</option>
                  <option value="Egypt">Egypt</option>
                </select>
                <small className="text-muted">Hold Ctrl (Cmd on Mac) to select multiple.</small>
              </div>

              <div className="mb-3">
                <label className="form-label">Time Zone</label>
                <select className="form-select" name="timeZone" value={formData.timeZone} onChange={handleChange}>
                  <option value="">Select Time Zone</option>
                  <option value="UTC +2">UTC +2</option>
                  <option value="UTC +3">UTC +3</option>
                  <option value="UTC +4">UTC +4</option>
                </select>
              </div>

              <div className="mb-3">
                <label className="form-label">Working Hours</label>
                <input
                  type="text"
                  name="workingHours"
                  className="form-control"
                  placeholder="Mon-Fri, 9am-5pm"
                  value={formData.workingHours}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        </div>

        {/* About Us */}
        <div className="col-md-12">
          <div className="card flex-fill">
            <div className="card-header">
              <div className="d-flex justify-content-between align-items-center">
                <h5 className="card-title">About Us</h5>
              </div>
            </div>
            <div className="card-body">
              <div className="mb-3">
                <label className="form-label">Who We Are</label>
                <input
                  type="text"
                  name="whoWeAre"
                  className="form-control"
                  placeholder="Description"
                  value={formData.whoWeAre}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Vision</label>
                <input
                  type="text"
                  name="vision"
                  className="form-control"
                  placeholder="Our vision"
                  value={formData.vision}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Mission</label>
                <input
                  type="text"
                  name="mission"
                  className="form-control"
                  placeholder="Our mission"
                  value={formData.mission}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Purpose</label>
                <input
                  type="text"
                  name="purpose"
                  className="form-control"
                  placeholder="Our purpose"
                  value={formData.purpose}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Social Network Links */}
        <div className="col-md-12">
          <div className="card flex-fill">
            <div className="card-header">
              <div className="d-flex justify-content-between align-items-center">
                <h5 className="card-title">Social Network Links</h5>
              </div>
            </div>
            <div className="card-body">
              <div className="mb-3">
                <label className="form-label">Facebook</label>
                <input
                  type="text"
                  name="facebookUrl"
                  className="form-control"
                  placeholder="Facebook URL"
                  value={formData.facebookUrl}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Instagram</label>
                <input
                  type="text"
                  name="instagramUrl"
                  className="form-control"
                  placeholder="Instagram URL"
                  value={formData.instagramUrl}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">WhatsApp</label>
                <input
                  type="text"
                  name="whatsappNumber"
                  className="form-control"
                  placeholder="WhatsApp Number"
                  value={formData.whatsappNumber}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">LinkedIn</label>
                <input
                  type="text"
                  name="linkedinProfile"
                  className="form-control"
                  placeholder="LinkedIn Profile"
                  value={formData.linkedinProfile}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Skype</label>
                <input
                  type="text"
                  name="skypeId"
                  className="form-control"
                  placeholder="Skype ID"
                  value={formData.skypeId}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-12">
          <div className="card flex-fill">
            <div className="card-body">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  name="approveNow"
                  id="approveNow"
                  checked={formData.approveNow}
                  onChange={handleChange}
                />
                <label className="form-check-label" htmlFor="approveNow">
                  Approve company immediately
                </label>
              </div>
            </div>
          </div>
        </div>

        {/* Save Button */}
        <div className="mt-4">
          <button type="submit" className="btn btn-turquoise" disabled={loading}>
            {loading ? "Saving..." : "Save Company Profile"}
          </button>
        </div>
      </div>
    </form>
  )
}
